module.exports = __webpack_public_path__ + "static/media/buildingConstruction15.a995f2a7.jpg";